import { createSlice } from '@reduxjs/toolkit';
import { panApi } from './panApi';

const initialState = {
  panData: null,
  loading: false,
  error: null,
};

const panSlice = createSlice({
  name: 'panLookup',
  initialState,
  reducers: {
    resetPanData: (state) => {
      state.panData = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const { resetPanData } = panSlice.actions;

export default panSlice.reducer;
